import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'

Vue.use(Vuex)

//===============================================
// Import stores from modules
//===============================================
import UserStore from '@/modules/auth/stores/userStore'
import RefStore from '@/modules/refs/stores/refStore'
import EvalStore from '@/modules/evaluations/stores/evalStore'
import CandidateStore from '@/modules/candidates/stores/candidateStore'

//===============================================
// Create main store with modules
//===============================================
const stores = new Vuex.Store({
    modules: {
        UserStore,
        RefStore,
        EvalStore,
        CandidateStore
    }
})

export default stores;